import { useState } from "react";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center py-16">
      <div className="w-full max-w-md paper-card p-10">
        <h1 className="heading-3">Forgot Password</h1>
        <p className="body-copy mt-2 text-ink-muted text-sm">
          Enter your email and we will send a reset link. For security, we do not reveal whether an email exists in
          our system.
        </p>
        {sent ? (
          <p className="mt-8 text-forest text-sm">
            If that email is registered, a reset link has been sent. For local testing, check backend logs for the
            reset URL.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email"
              className="w-full border border-border bg-paper px-4 py-3 text-sm focus:outline-none focus:border-ink"
            />
            <button className="btn-primary w-full justify-center" type="submit">Send Reset Link</button>
          </form>
        )}
        <div className="mt-8 text-center text-xs">
          <Link to="/elder-login" className="text-ink-muted hover:text-forest">← Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
